import { connect } from 'react-redux';
import { useEffect } from 'react';
import { FontIcon, Spinner } from '@fluentui/react';
import { ProtocolPractitionerItemComponent } from './ProtocolPractitioner.Item';

// functions 
import * as ComponentFunctions from './ProtocolPractitioner.List.Functions';

////i18Next
import { useTranslation } from 'react-i18next';

//styles
import './ProtocolPractitioner.style.css';


const ProtocolParactitionersListComponent = (props: ComponentFunctions.Props) => {

    const [t] = useTranslation();

    useEffect(() => {
        if (!props.Protocol)
            props.GetMedicalProtocolById(props.ProtocolId);
    }, [props.ProtocolId !== undefined]);

    useEffect(() => {
        if (props.Protocol)
            props.GetAllProtocolPractitioners(props.Protocol.id);
    }, [props.Protocol !== undefined]);

    useEffect(() => {
        props.GetAllContractsConcept(props.ContractId, undefined);
        props.GetAllContractCommissionAgents(props.ContractId);
    }, [props.ContractId !== undefined && props.Contract?.commissionAgents.length === 0]);

    if (props.isPractitionerLoading) {
        return (
            <div className="pp-list__loading">
                <Spinner label={t('protocolPractitionerlist.practitioner.loading')} ariaLive="assertive" labelPosition="right" />
            </div>
        );
    }

    if (!props.Practitioners || props.Practitioners.length === 0) {
        return (
            <div className="pp-list__empty">
                <FontIcon iconName="People" className="pp-list__empty-icon" />
                <p>{t('protocolPractitionerlist.practitioner.noPractitioners')}</p>
            </div>
        );
    }

    return (
        <div className="pp-list__grid">
            {props.Practitioners.map((practitioner, index) => (
                <ProtocolPractitionerItemComponent
                    key={`${practitioner.practitionerUserId}-${index}`}
                    practitioner={practitioner}
                    contractId={props.ContractId}
                    GetPractiontioner={props.GetPractiontioner}
                    Protocol={props.Protocol}
                />
            ))}
        </div>
    );

};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ProtocolParactitionersListComponent as any)
